import {
  ASSET_TYPE,
  CANTEMO_DROPDOWN_FIELDS,
  CANTEMO_LANGUAGE_VARIANTS,
  CantemoFilters,
  EMPTY_CANTEMO_FILTERS,
  MEDIA_SEARCH,
} from "../constants/MediaSearch";

export const expandCantemoLanguages = (selected: string[] = []) => {
  const expanded: string[] = [];
  selected.forEach((code) => {
    const variants = CANTEMO_LANGUAGE_VARIANTS[code];
    if (variants) {
      variants.forEach((value) => {
        if (!expanded.includes(value)) {
          expanded.push(value);
        }
      });
      return;
    }
    if (!expanded.includes(code)) {
      expanded.push(code);
    }
  });
  return expanded;
};

export const hasCantemoFilters = (filters = EMPTY_CANTEMO_FILTERS) =>
  Boolean(
    filters.title?.trim() ||
    filters.episodeTitle?.trim() ||
    filters.episodeNumber?.trim() ||
    filters.generationType?.length ||
    filters.language?.length ||
    filters.fileFormat?.length ||
    filters.frameRate?.length ||
    filters.mimeType?.length
  );

export const buildCantemoValidatePayload = (filters: CantemoFilters = EMPTY_CANTEMO_FILTERS, page = 0) => {
  const comboFilters: Record<string, string | string[]> = {};
  const title = (filters.title || "").trim();
  const episodeTitle = (filters.episodeTitle || "").trim();
  const episodeNumber = (filters.episodeNumber || "").trim();
  if (title) {
    comboFilters.title = title;
  }
  if (episodeTitle) {
    comboFilters.episodeTitle = episodeTitle;
  }
  if (episodeNumber) {
    comboFilters.episodeNumber = episodeNumber;
  }
  CANTEMO_DROPDOWN_FIELDS.forEach(({ key }) => {
    const values = filters[key];
    if (values.length) {
      comboFilters[key] = key === "language" ? expandCantemoLanguages(values) : values;
    }
  });
  const fallbackId = CANTEMO_DROPDOWN_FIELDS
    .map(({ key }) => filters[key]?.[0] || "")
    .find((value) => value);
  return [{
    id: title || episodeTitle || episodeNumber || fallbackId || "cantemo",
    idType: "cantemotitle",
    searchInactive: false,
    filters: comboFilters,
    page,
    pageSize: MEDIA_SEARCH.cantemoPageSize,
  }];
};

export const isCantemoValidAssets = (validAssets = {}) =>
  Object.values(validAssets).some((asset: { idType?: string }) => asset?.idType === ASSET_TYPE.CANTEMO);

export const getCantemoPageKeys = (validAssets = {}, page = 0) => {
  const keys = Object.keys(validAssets);
  const start = page * MEDIA_SEARCH.cantemoPageSize;
  return keys.slice(start, start + MEDIA_SEARCH.cantemoPageSize);
};

export const getCantemoPageCount = (validAssets = {}, total = null) =>
  Math.max(1, Math.ceil((total ?? Object.keys(validAssets).length) / MEDIA_SEARCH.cantemoPageSize));
